'use client';

import type { BoxProps } from '@chakra-ui/react';

import CardArticle from '../blog/cardArticle';
import Slider from '../slider/slider';

import type { Article } from '@lib/types/directus/directusSchema';

interface Props {
  articles: Article[];
  itemWidth: BoxProps['width'];
  align?: BoxProps['scrollSnapAlign'];
}

export default function FauconisArticlesSlider({ articles, itemWidth, align = 'center' }: Props) {
  return (
    <Slider each={articles} itemWidth={itemWidth} align={align}>
      {(article, i) => <CardArticle article={article} key={`${article.title}_${i}`} isHomepage mobile />}
    </Slider>
  );
}
